import { BASE_URL } from '../services/ApiService/ApiConfig';
import { tokenActual } from './sesionCliente';

const RAIZ = `${BASE_URL}/dispositivo-maestro`;

/** Llamada a la API del maestro de dispositivos; los errores traen el mensaje del servidor. */
export async function disp(ruta, metodo = 'GET', cuerpo) {
    const res = await fetch(`${RAIZ}${ruta}`, {
        method: metodo,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenActual()}` },
        body: cuerpo === undefined ? undefined : JSON.stringify(cuerpo)
    });
    const datos = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(datos.mensaje || `Error ${res.status}`);
    return datos;
}

export const listarDispositivos = (q) => disp(`?${q}`);
export const tiposDispositivo = () => disp('/tipos');
export const verificarIdentificador = (q) => disp(`/verificar?${q}`);
export const historialDispositivo = (id) => disp(`/${id}/historial`);
export const crearDispositivo = (c) => disp('', 'POST', c);
export const modificarDispositivo = (id, c) => disp(`/${id}`, 'PUT', c);
